window.addEventListener("DOMContentLoaded", () => {
  const jdg_review = document.querySelector(".product__rating");
  if (jdg_review) {
    jdg_review.addEventListener("click", () => {
      // $('html, body').animate({
      //     scrollTop: $('#judgeme_product_reviews').offset().top + 60
      // }, 300);
      document.querySelector("#judgeme_product_reviews").scrollIntoView({
        behavior: "smooth", // 平滑滚动
      });
    });
  }
});
